import I10n from "../../features/i10n";
import { appConfiguration } from "../app-starter";

export const buildLicenseGroups = (softwareLicenses) => {

  const licenses = JSON.parse(JSON.stringify(softwareLicenses));

  const groups = new Map();

  for (const licence of licenses) {

    if (groups.get(licence.licenceGroup)) {
      groups.get(licence.licenceGroup).licences.push(licence);
    } else {
      groups.set(licence.licenceGroup, {licences : [licence],  name: I10n.getOrDefault(`bom.licence.licencegroup.name.${licence.licenceGroup}`, licence.licenceGroup)});
    }
  }

  return  [...groups.values()].map((group) => {
    const licenseMap = new Map();

    group.licences.forEach((license) => {
      if (licenseMap.get(license.id)) {
        licenseMap.get(license.id).quantity += license.quantity;
      } else {
        licenseMap.set(license.id, license);
      }
    });

    group.licences = [...licenseMap.values()];
    return group;
  });
}

export const shouldDisplaySoftwareLicenseData = () => {
  return (window.top === window.self || appConfiguration.launchFromWorkspace || appConfiguration.unifiedCheckoutAvailable);
}
